module.exports = __webpack_public_path__ + "static/media/job-detail.08dfb67e.jpg";